import {PAF_DB_KEYS} from './paf-form/constants'

//keys to be used in the backend
const APPOINTMENT_KEYS = {
  VITALS_KEY: 'vitals',
  ...PAF_DB_KEYS
}

export default APPOINTMENT_KEYS;